import { ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { DefaultChipStyling } from './interfaces';
import { MatRippleModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

type ComponentSize = 'default' | 'large';
const SelectedChipIcon = 'done';

@Component({
  selector: 'crm-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  imports: [CommonModule, GalaxyBadgeModule, MatIconModule, MatRippleModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
  private readonly _icon = signal<string | undefined>(undefined);
  private readonly _selected = signal(false);
  private readonly _hideLabelWhenSelected = signal(false);

  @Input({ transform: coerceBooleanProperty })
  set hideLabelWhenSelected(value: boolean) {
    this._hideLabelWhenSelected.set(value);
  }
  @Input()
  set icon(value: string | undefined) {
    this._icon.set(value);
  }
  get icon(): string | undefined {
    return this._icon();
  }
  @Input({ required: true }) label = '';
  @Input({ transform: coerceBooleanProperty })
  set selected(value: boolean) {
    this._selected.set(value);
  }
  get selected(): boolean {
    return this._selected();
  }
  @Input() size: ComponentSize = 'default';

  protected readonly color = computed(() => {
    return this._selected() ? DefaultChipStyling.selectedChipColor! : DefaultChipStyling.unselectedChipColor!;
  });
  protected readonly chipIcon = computed(() => {
    if (this._selected() && !this._hideLabelWhenSelected()) {
      return SelectedChipIcon;
    }
    return this._icon();
  });

  protected readonly hideLabel = computed(() => {
    if (!this._icon()) {
      return false;
    }
    if (this._selected()) {
      return false;
    }
    return this._hideLabelWhenSelected() || false;
  });
}
